import { render, staticRenderFns } from "./Footbar.vue?vue&type=template&id=2dba9d85&"
import script from "./Footbar.vue?vue&type=script&lang=js&"
export * from "./Footbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dba9d85')) {
      api.createRecord('2dba9d85', component.options)
    } else {
      api.reload('2dba9d85', component.options)
    }
    module.hot.accept("./Footbar.vue?vue&type=template&id=2dba9d85&", function () {
      api.rerender('2dba9d85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/partials/Footbar.vue"
export default component.exports